// extracted by mini-css-extract-plugin
export default {"menuSearch":"styles__menuSearch___OCfTO","searchLink":"styles__searchLink___p1Ffb","searchIcon":"styles__searchIcon___Yc6AR"};